import { createFileRoute } from '@tanstack/react-router';

import { CitationBrowse } from '@/module/Author/Citation/CitationBrowse';

export const Route = createFileRoute('/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { abstractId } = Route.useParams();
  return <CitationBrowse publicationId={abstractId} />;
}
